import { render, staticRenderFns } from "./StepComponent.vue?vue&type=template&id=42c3af73&scoped=true"
import script from "./StepComponent.vue?vue&type=script&lang=js"
export * from "./StepComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c3af73",
  null
  
)

export default component.exports